import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import AddBoxOutlinedIcon from "@material-ui/icons/AddBoxOutlined";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import CloseIcon from "@material-ui/icons/Close";
import DoneIcon from "@material-ui/icons/Done";
import Button from "@material-ui/core/Button";


import React, { useEffect, useState, makeStyles } from "react";

import './dnd.css';

export default function AddEmail({ show, setShow, onSend, task }) {
  const [emailListChanged, setEmailListChanged] = useState(false);
  const [emailList, setEmailList] = useState([]);
  const [addEmail, setAddEmail] = useState(true);
  const [newEmail, setNewEmail] = useState({email:""});

  const [isEmpty, setIsEmpty] = useState(true);

  const deleteEmail = (email) =>{
    let i = emailList.findIndex((e)=>e.email === email.email);
    emailList.splice(i,1);

  }
  const addNewEmail = (email) =>{
    // emails.push(email);
    emailList.push(email);
    setIsEmpty(false)
    console.log("Adding email" + email.email)

  }


  useEffect(() => {
    let mounted = true;

    emailList.map((envs) => {
      if (mounted) {
        setEmailList(envs);
        setEmailListChanged(false);
      }
    });
    return () => {
      mounted = false;
    };
  }, emailListChanged);

  function updateEmail(e, email) {}

  function deleteThisEmail(e, email) {
    deleteEmail(email);
    setEmailListChanged(true);
  }

  function handleOnChangeAddEmail(e) {
    
    let l = {...newEmail};
    l.email = e.target.value;
    setNewEmail(l);
  }


  function displayAddEmail() {
    if (addEmail) {
    //   setAddEmail(false);
      return (
      <tr>
          <td>
            <input  
              type='email'
              style={{width: '40ch', height:'30px', fontSize:20}}
              required
              label="Required"
              id="EmailName"
            //   value={newEmail.name}
              onChange={(e) => {
                handleOnChangeAddEmail(e);
              }}
            />
          </td>
          <td>
             
            <IconButton onClick={() => handleOnClickDone()}>
              <DoneIcon />
            </IconButton>
         
         
            <IconButton onClick={() => handleOnClickClose()}>
              <CloseIcon />
            </IconButton>
          
        
          </td>
        </tr>


      );
    }

    return "";
  }

  function handleOnClickDone() {
    addNewEmail(newEmail);
    setEmailListChanged(true);
    setAddEmail(false);
    }

  function handleOnClickClose() {
    setAddEmail(false);
    setEmailListChanged(true);
  }

  function handleOnClickSend() {
    console.log(emailList)
    var emails=[]
    
    emailList.map(email=>{
      emails.push(email.email)
    })

    onSend(task, emails)

    setEmailList([])
    setIsEmpty(true)
    setShow(false)
    setAddEmail(true)
  }

  function displayActions(env) {
    
    return (
      <>
        {/* <Tooltip title="Update Email">
          <IconButton onClick={(e) => updateEmail(e, env)}>
            <EditIcon></EditIcon>
          </IconButton>
        </Tooltip> */}
        {/* <Tooltip title="Delete Email">
          <IconButton onClick={(e) => deleteEmail(e, env)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip> */}
      </>
    );
  }

  if (!show) {
    return "";
  }


  // const useStyles = makeStyles((theme) => ({
  //   root: {
  //     backgroundColor: "#fff",
  //     borderRadius: 4,
  //   },
  //   button: {
  //     margin: theme.spacing(1),
  //     float: "right",
  //     paddingBottom: 1,
  //   },
  // }));


  return (
    <div className="modal">
      <div className="modal-content addmodalwidth">
        {/* <Grid container> */}
        <h1 style={{ fontSize: "large", color: "#336b70" }}>
          Invitation Emails for {task.taskName}
        </h1>
        <Tooltip title="Close">
          <IconButton
            style={{ float: "right", position: "absolute", right: 0, top: 0 }}
            onClick={() => {     
              setEmailList([])
              setIsEmpty(true)
              setShow(false)
            }
           }
          >
            <CloseOutlinedIcon />
          </IconButton>
        </Tooltip>

        <Tooltip title="Add Email">
          <IconButton
            style={{ float: "right" }}
            onClick={() => setAddEmail(true)}
          >
            <AddBoxOutlinedIcon />
          </IconButton>
        </Tooltip>

        <table className="amictb">
          <tr>
            <th>Emails</th>
            <th>Actions</th>
          </tr>
          {displayAddEmail()}
          {emailList.map((env) => (
            <tr>
              <td>{env.email}</td>
              <td>
                {displayActions(env)}
              </td>
            </tr>
          ))}
  
        </table>
        <Button
            className='dialogbutton'
            color="primary"
            onClick={handleOnClickSend}
            disabled={isEmpty}
        >Send</Button>

        {/* </Grid> */}
      </div>
    </div>
  );
}
